module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-wrap",
    class: {
      'kiwi-wrap--statebrowser-drawopen': _vm.stateBrowserDrawOpen,
      'kiwi-wrap--monospace': _vm.setting('useMonospace'),
        'kiwi-wrap--touch': _vm.state.ui.is_touch,
    },
    on: {
      "click": _vm.emitDocumentClick
    }
  }, [_c('link', {
    attrs: {
      "href": _vm.themeUrl,
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), (!_vm.hasStarted || (!_vm.fallbackComponent && _vm.networks.length === 0)) ? [_c(_vm.startupComponent, {
    tag: "component",
    on: {
      "start": _vm.startUp
    }
  })] : [_c('state-browser', {
    attrs: {
      "networks": _vm.networks
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kiwi-workspace",
    on: {
      "click": function($event) {
        _vm.stateBrowserDrawOpen = false
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-workspace-background"
  }), _vm._v(" "), (!_vm.activeComponent && _vm.network) ? [_c('container', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "users": _vm.users,
      "isHalfSize": _vm.mediaviewerOpen
    }
  }), _vm._v(" "), (_vm.mediaviewerOpen) ? _c('media-viewer', {
    attrs: {
      "url": _vm.mediaviewerUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('control-input', {
    attrs: {
      "container": _vm.networks,
      "buffer": _vm.buffer
    }
  })] : (!_vm.activeComponent) ? _c(_vm.fallbackComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.fallbackComponentProps, false)) : _c(_vm.activeComponent, _vm._b({
    tag: "component"
  }, 'component', _vm.activeComponentProps, false))], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26f750b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 482
// module chunks = 2